<app-label isBig><ng-content></ng-content></app-label>
<div class="dashed-line"></div>
